import {
  SYS_ADMIN,
  AFF_ADMIN,
  MEMBERSHIP_ADMIN,
  POLITICAL_ADMIN,
  MEMBERSHIP_ROLES,
  POLITICAL_ROLES,
} from "@/constants/roles";

const userHasRolesInTwoWorkflows = (user) => {
  // return user has more than one role && at there is at least one role in either workflow
  return (
    user.role.length > 1 &&
    user.role.some((role) => MEMBERSHIP_ROLES.includes(role)) &&
    user.role.some((role) => POLITICAL_ROLES.includes(role))
  );
};

export const canManageAllUsers = (user) => {
  if (!user?.role) return false;
  return (
    user.role.includes(SYS_ADMIN) ||
    user.role.includes(MEMBERSHIP_ADMIN) ||
    user.role.includes(POLITICAL_ADMIN)
  );
};

export const canManageOwnUsers = (user) => {
  if (!user?.role) return false;
  return (
    user.role.includes(SYS_ADMIN) ||
    user.role.includes(MEMBERSHIP_ADMIN) ||
    user.role.includes(AFF_ADMIN) ||
    user.role.includes(POLITICAL_ADMIN)
  );
};

export const canAccessUsersPage = (user) => {
  if (!user?.role) return false;
  return (
    user.role.includes(SYS_ADMIN) ||
    user.role.includes(MEMBERSHIP_ADMIN) ||
    user.role.includes(AFF_ADMIN) ||
    user.role.includes(POLITICAL_ADMIN)
  );
};

export const canDeleteProcessedFile = (user) => {
  if (!user?.role) return false;
  return user.role.includes(SYS_ADMIN) || user.role.includes(MEMBERSHIP_ADMIN);
};

export const canDeleteDataFile = (user) => {
  if (!user?.role) return false;
  return (
    user.role.includes(SYS_ADMIN) ||
    user.role.includes(MEMBERSHIP_ADMIN) ||
    user.role.includes(AFF_ADMIN)
  );
};

export const canViewAllAffiliates = (user) => {
  if (!user?.role) return false;
  return (
    user.role.includes(SYS_ADMIN) ||
    user.role.includes(MEMBERSHIP_ADMIN) ||
    user.role.includes(POLITICAL_ADMIN)
  );
};

export const canSeeIEB = (user) => {
  if (!user?.role) return false;
  return user.role.includes(SYS_ADMIN) || user.role.includes(MEMBERSHIP_ADMIN);
};

export const canEditIEB = (user) => {
  if (!user?.role) return false;
  return user.role.includes(SYS_ADMIN) || user.role.includes(MEMBERSHIP_ADMIN);
};

export const canChangeWorkflow = (user) => {
  if (!user?.role) return false;
  return user.role.includes(SYS_ADMIN) || userHasRolesInTwoWorkflows(user);
};

export const politicalWorkflowOnly = (user) => {
  if (!user?.role) return false;
  return !user.role.some((role) => MEMBERSHIP_ROLES.includes(role));
};

export const canManageEvents = (user) => {
  if (!user?.role) return false;
  return user.role.includes(SYS_ADMIN) || user.role.includes(POLITICAL_ADMIN);
};

export const canAccessLogs = (user) => {
  if (!user?.role) return false;
  return user.role.includes(SYS_ADMIN);
};
